import './App.css';

import type React from 'react';
import { Suspense, useEffect } from 'react';
import { HashRouter } from 'react-router-dom';

import { Provider } from 'jotai';

import AppConfig from './AppConfig';
import { Agreement } from './components/Agreement';
import { SideMenu } from './components/menu/SideMenu';
import { LoadingFallback } from './components/progress/LoadingFallback';
import Layout from './pages/Layout';
import { AmplitudeAnalyticsController } from './util/analytics/AmplitudeAnalyticsController';
import { analytics } from './util/analytics/AnalyticsController';
import type { AnalyticsControllerType } from './util/analytics/AnalyticsController.types';

const initializeAnalytics = () => {
  analytics.register(
    [AppConfig.amplitudeApiKey && new AmplitudeAnalyticsController(AppConfig.amplitudeApiKey)].filter(Boolean) as Array<
      Partial<AnalyticsControllerType>
    >,
  );
};

const App: React.FC = () => {
  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <Provider>
      <HashRouter>
        <Agreement />
        <SideMenu>
          <Suspense fallback={<LoadingFallback />}>
            <Layout />
          </Suspense>
        </SideMenu>
      </HashRouter>
    </Provider>
  );
};

export default App;
